import { component } from 'picoapp';
import jump from 'jump.js';
import getClosest from '../../utils/getClosest';

class Accordion {
  constructor(el, ctx) {
    this.ctx = ctx;
    this.identifier = el.dataset.identifier;
    this.init(el);
    this.bindEvents();
  }

  init(el) {
    this.el = el;
    this.items = el.querySelectorAll('.Accordion__item');
    // this.handleHashUpdate(false);
  }

  bindEvents() {
    this.items.forEach((element) => {
      element.addEventListener('click', (e) => {
        if (e.target.classList.contains('Accordion__toggle') || getClosest(e.target, '.Accordion__toggle')) {
          e.preventDefault();
          this.toggleItem(element);
        }
      });
    });
    window.onhashchange = this.handleHashUpdate.bind(this);
  }

  toggleItem(el) {
    if (el.classList.contains('is-active')) {
      el.classList.remove('is-active');
    } else {
      el.classList.add('is-active');
    }
    var optionsArray = Array.prototype.slice.call(this.items);
    var filteredArray = optionsArray.filter((item) => !item.isEqualNode(el));
    filteredArray.forEach((el) => {
      el.classList.remove('is-active');
    });
  }

  handleHashUpdate(autoScroll) {
    if (!window.location.hash) return; // Account for calls without an actual hash change

    const newPanel = this.el.querySelector(':scope > [data-identifier=' + window.location.hash.substring(1) + ']');

    if (newPanel) {
      this.toggleItem(newPanel);

      if (autoScroll) {
        // Scroll tabs into view
        // const panelPos = newPanel.offsetTop - 140;
        jump(newPanel, {
          duration: 600,
          offset: -100,
          a11y: false
        });
        // setTimeout(() => {
        //   window.scrollTo({
        //     top: panelPos,
        //     behavior: 'smooth' // Optional, adds animation
        //   });
        // }, 200);
      }
    }
  }
}

export default component((node, ctx) => {
  new Accordion(node, ctx);
});
